import React, { useEffect, useState } from 'react';
import { supabaseAdmin } from '../config/supabase';
import toast from 'react-hot-toast';
import './NewsManagement.css';

export default function CategoriesManagement() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
  });

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabaseAdmin
        .from('interactive_map_categories')
        .select('*')
        .order('name', { ascending: true });

      if (error) throw error;
      setCategories(data || []);
    } catch (error) {
      toast.error('Błąd podczas ładowania kategorii');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (category = null) => {
    if (category) {
      setEditingCategory(category);
      setFormData({
        name: category.name || '',
      });
    } else {
      setEditingCategory(null);
      setFormData({
        name: '',
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingCategory(null);
    setFormData({
      name: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error('Nazwa kategorii jest wymagana');
      return;
    }

    try {
      if (editingCategory) {
        // Update existing category
        const { error } = await supabaseAdmin
          .from('interactive_map_categories')
          .update({
            name: formData.name.trim(),
            updated_at: new Date().toISOString(),
          })
          .eq('id', editingCategory.id);

        if (error) throw error;
        toast.success('Kategoria zaktualizowana');
      } else {
        // Create new category
        const { error } = await supabaseAdmin
          .from('interactive_map_categories')
          .insert({
            name: formData.name.trim(),
          });

        if (error) throw error;
        toast.success('Kategoria utworzona');
      }

      handleCloseModal();
      loadCategories();
    } catch (error) {
      toast.error('Błąd podczas zapisywania kategorii');
      console.error(error);
    }
  };

  const handleDelete = async (categoryId) => {
    if (!window.confirm('Czy na pewno chcesz usunąć tę kategorię? Miejsca przypisane do tej kategorii nie zostaną usunięte, ale kategoria zostanie od nich odłączona.')) {
      return;
    }

    try {
      // First, delete all place-category relationships
      const { error: junctionError } = await supabaseAdmin
        .from('interactive_map_place_categories')
        .delete()
        .eq('category_id', categoryId);

      if (junctionError) throw junctionError;

      // Then delete the category
      const { error } = await supabaseAdmin
        .from('interactive_map_categories')
        .delete()
        .eq('id', categoryId);

      if (error) throw error;
      toast.success('Kategoria usunięta');
      loadCategories();
    } catch (error) {
      toast.error('Błąd podczas usuwania kategorii');
      console.error(error);
    }
  };

  if (loading) {
    return (
      <div className="admin-page">
        <div className="admin-header">
          <h1>Kategorie - Mapa interaktywna</h1>
          <button className="btn btn-primary" onClick={() => handleOpenModal()}>
            Dodaj kategorię
          </button>
        </div>
        <div className="loading">Ładowanie...</div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Kategorie - Mapa interaktywna</h1>
        <button className="btn btn-primary" onClick={() => handleOpenModal()}>
          Dodaj kategorię
        </button>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Nazwa</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {categories.length === 0 ? (
              <tr>
                <td colSpan="2" className="empty-state">
                  Brak kategorii. Dodaj pierwszą kategorię.
                </td>
              </tr>
            ) : (
              categories.map((category) => (
                <tr key={category.id}>
                  <td>{category.name}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => handleOpenModal(category)}
                    >
                      Edytuj
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(category.id)}
                    >
                      Usuń
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingCategory ? 'Edytuj kategorię' : 'Dodaj kategorię'}</h2>
              <button className="modal-close" onClick={handleCloseModal}>
                ×
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nazwa kategorii *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  placeholder="np. Restauracje, Hotele, Atrakcje"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Anuluj
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingCategory ? 'Zaktualizuj' : 'Utwórz'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
